import React from 'react'
import { PageHome } from '@homeviews/outreach'

export const OutreachHome = () => <PageHome />
